import Button from '@material-ui/core/Button';
import styled from 'styled-components';

import { ErrorBoundaryWithRetry, Card } from '@feedback/ui';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin: 10px;
`;

const Text = styled.p`
  margin-bottom: 20px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
`;

type Props = {
  error: string;
  retry?: () => void;
};
const ErrorView = ({ error, retry = undefined }: Props) => {
  const errorMessage = Array.isArray(error) ? error[0].message : error.message;

  return (
    <Wrapper>
      <Container>
        <Card m='20px' p='20px' flexDirection='column' alignItems='center'>
          <h3>Ops! Ocorreu um erro</h3>
          <Text>{errorMessage}</Text>
          {retry && (
            <Button variant='outlined' onClick={retry}>
              Tentar novamente
            </Button>
          )}
        </Card>
      </Container>
    </Wrapper>
  );
};

export const ErrorViewBoundary = ({ children }) => {
  return (
    <ErrorBoundaryWithRetry
      fallback={(error, retry) => <ErrorView error={error} retry={retry} />}
    >
      {({ fetchKey }) => children({ fetchKey })}
    </ErrorBoundaryWithRetry>
  );
};

export default ErrorView;
